import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { RiskProfilesService } from 'RiskProfilesApp/services/risk-profiles.service';
import { formFlattenedObject } from 'Angular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "RiskProfilesApp/services/risk-profiles.service";
export class RiskProfileFolderableCollectionListModalService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.dataParams));
        return this.riskProfileService.getFolderableItems(dataParams);
    }
    constructor(riskProfileService) {
        super();
        this.riskProfileService = riskProfileService;
        this.scrollableBodyId = 'riskProfilesModalTable';
    }
}
RiskProfileFolderableCollectionListModalService.ɵfac = function RiskProfileFolderableCollectionListModalService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfileFolderableCollectionListModalService)(i0.ɵɵinject(i1.RiskProfilesService)); };
RiskProfileFolderableCollectionListModalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RiskProfileFolderableCollectionListModalService, factory: RiskProfileFolderableCollectionListModalService.ɵfac });
